import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const sessionGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  if (auth.isTokenValid()) return true;
  inject(Router).navigate(['/unauthorized']);
  return false;
};
